import { isValidPhoneNumber, isSupportedCountry } from "libphonenumber-js";
import * as Yup from "yup";
var YUP_PHONE_METHOD = "phone";
var isValidCountryCode = function isValidCountryCode(countryCode) {
  if (typeof countryCode !== "string") {
    return false;
  }
  return isSupportedCountry(countryCode);
};
Yup.addMethod(Yup.string, YUP_PHONE_METHOD, function yupPhoneLite(countryCode, errorMessage) {
  if (countryCode === void 0) {
    countryCode = "US";
  }
  var countryCodes = typeof countryCode === "string" ? [countryCode] : [].concat(countryCode);
  var validCountryCodes = countryCodes.filter(isValidCountryCode);
  if (!validCountryCodes.length) {
    validCountryCodes = ["US"];
  }
  var errMsg = typeof errorMessage === "string" && errorMessage ? errorMessage : "${path} must be a valid phone number for region" + (validCountryCodes.length > 1 ? "s" : "") + " " + validCountryCodes.join(", ");
  return this.test(YUP_PHONE_METHOD, errMsg, function (value) {
    try {
      if (value === undefined || value === "") {
        return true;
      }
      var isValid = validCountryCodes.reduce(function (isValidAccum, validCountryCode) {
        var isValidPhone = isValidPhoneNumber(value, validCountryCode);
        return isValidAccum || isValidPhone;
      }, false);
      return isValid;
    } catch (_unused) {
      return false;
    }
  });
});
//# sourceMappingURL=yup-phone-lite.js.map